import React from 'react'

import {
  classnames,
  Icon,
  ArrowRight,
  Radio,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string, func } from 'prop-types'

import roundHumanCount from 'Utils/roundHumanCount'

function SubscriptionOption({
  selected,
  onSelect: handleSelect,
  downloadsPerMonth,
  catalogValue,
  pricePerModel,
  perModelLabel,
  fromLabel,
}) {
  const optionClass = classnames(
    'subscription-purchase__option',
    'subscription-purchase__option--subscription',
    selected && 'subscription-purchase__option--selected'
  )

  return (
    <div
      className={optionClass}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleSelect()
        }
      }}
      role="button"
      tabIndex={0}
    >
      <div className="subscription-purchase__option-radio">
        <Radio
          name="purchaseOption"
          isChecked={selected}
          onChange={handleSelect}
          className="subscription-purchase__radio"
        />
      </div>

      <div className="subscription-purchase__option-content">
        <div className="subscription-purchase__option-header">
          <span className="subscription-purchase__option-title">Subscription</span>
          <div className="subscription-purchase__option-price">
            <div className="subscription-purchase__option-price-row">
              <span className="cgt-body-base subscription-purchase__from-prefix">
                {fromLabel}
              </span>
              <span className="subscription-purchase__current-price">{pricePerModel}</span>
            </div>
            <span className="cgt-caption-semibold subscription-purchase__per-model-label">
              {`/${perModelLabel}`}
            </span>
          </div>
        </div>
        <ul className="subscription-purchase__benefits-list">
          <li className="subscription-purchase__benefits-item">Designed to meet your everyday needs</li>
          <li className="subscription-purchase__benefits-item">
            Download up to
            {' '}
            <strong className="subscription-purchase__benefits-highlight">
              {downloadsPerMonth} models
            </strong>
            {' '}
            per month
          </li>
          <li className="subscription-purchase__benefits-item">
            Access a library of
            {' '}
            <strong className="subscription-purchase__benefits-highlight">{roundHumanCount(catalogValue)}</strong>
            {' '}
            premium models
          </li>
        </ul>
        <a
          href="/subscription"
          className="subscription-purchase__learn-more"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          Learn more
          <Icon svgComponent={ArrowRight} size="small" />
        </a>
      </div>
    </div>
  )
}

SubscriptionOption.propTypes = {
  selected: bool.isRequired,
  onSelect: func.isRequired,
  downloadsPerMonth: number.isRequired,
  catalogValue: string.isRequired,
  pricePerModel: string.isRequired,
  perModelLabel: string.isRequired,
  fromLabel: string.isRequired,
}

export default SubscriptionOption
